import { render, staticRenderFns } from "./ListPuestos.vue?vue&type=template&id=8ea6177c&"
import script from "./ListPuestos.vue?vue&type=script&lang=js&"
export * from "./ListPuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports